  import { Badge } from '@chakra-ui/layout';
  import { DateTime } from 'luxon';
  import { useContext, useEffect, useState } from 'react';
  import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
  import { FeatureContext } from '../../../Context';
  import { lang } from '../../../Utils';
  import { Table } from '../../../components/table/Table';
  import 'react-vertical-timeline-component/style.min.css';
  import { BsCalendar3, BsCalendarEvent, BsCalendarWeek, BsCalendarX } from 'react-icons/bs';

  const verticalItemStyles = {
    content: {
      data: {
        background: '#F0F8FC',
        color: '#000',
        padding: "10px",
        boxShadow: "0 0 8px 1px rgb(0,0,0,0.2)"
      },
      noData: {
        background: 'transparent',
        boxShadow: 'none',
        color: '#000' }
    },
    contentIcon: {
      data: { borderRight: '7px solid #F0F8FC' },
      noData: { borderRight: '0px' }
    },
    icons: {
      passed: { background: 'rgb(227 29 29)', color: '#fff' },
      today: { background:'rgb(19 149 25)', color: '#fff' },
      minor2week: { background: 'rgb(34,109, 57)', color: '#fff' },
      major2week: { background: 'rgb(38, 111, 193)', color: '#fff' }
    }
  }

  const ExpectedDeliveryDate = ({ data }) => {
    return data.expectedDeliveryDate
        ? DateTime.fromISO(data.expectedDeliveryDate).toFormat('dd/MM/yyyy')
        : ''; // Campo vuoto se la data non è presente
  };


  const ShippedBadge = ({ data }) => (data.isShipped) ? <Badge colorScheme='green'>{lang('Shipped')}</Badge> : null;

  const Item = ({ items, label, iconStyle, contentStyle, contentArrowStyle, icon }) =>  <VerticalTimelineElement
    style={{ minHeight: "30px" }}
    date={label}
    iconStyle={iconStyle}
    contentStyle={contentStyle}
    contentArrowStyle={contentArrowStyle}
    icon={icon}
    background="#fc0"
    visible={true}>
    {(!!items && items.length > 0) ?
      <Table dataSet={items} responsive={false} hover={false}>
        <Table.Caption>{lang('Details List')}</Table.Caption>
        <Table.Header>
          <Table.Header.Column className="text-center">{lang('Qty')}</Table.Header.Column>
          <Table.Header.Column className="text-center">{lang('Requested Date')}</Table.Header.Column>
          <Table.Header.Column className="text-center">{lang('Confirmed Date')}</Table.Header.Column>
          <Table.Header.Column className="text-center">{lang('Estimated delivery date')}</Table.Header.Column>
          <Table.Header.Column className="text-center">{lang('Shipped')}</Table.Header.Column>
        </Table.Header>
        <Table.Body noDataMessage={lang('No Data available to display')}>
          <Table.Body.Text className="text-center" field="confirmedQuantity" />
          <Table.Body.Date className="text-center" field="requestedDate" />
          <Table.Body.Date className="text-center" field="confirmedDeliveryDate" />
          <Table.Body.Component className="text-center" rendercomponent={ExpectedDeliveryDate} />
          <Table.Body.Component className="text-center" rendercomponent={ShippedBadge} />
        </Table.Body>
      </Table>
      : <div></div>}
  </VerticalTimelineElement>

  const Scheduling = () => {

    const context = useContext(FeatureContext);
    const [group, setGroup] = useState({
      'passed': [],
      'today': [],
      'minor2week': [],
      'major2week': []
    });

    useEffect(() => {
      const today = DateTime.now();

      const data = context?.detail?.scheduleLineDetail.reduce((group, item) => {
          //console.log(context?.detail);
          if(!item.expectedDeliveryDate) {
            var dateScheduling = item.confirmedDeliveryDate;
          } else {
            var dateScheduling = item.expectedDeliveryDate;
          }

          // Calcola la differenza in giorni
          const diff = DateTime.fromISO(dateScheduling).diff(today, ["days"]);

          if (parseInt(diff.values.days) < 0) {
            group.passed = [...group.passed, item];
          } else if (parseInt(diff.values.days) === 0) {
            group.today = [...group.today, item];
          } else if (parseInt(diff.values.days) > 0 && parseInt(diff.values.days) <= 14) {
            group.minor2week = [...group.minor2week, item];
          } else {
            group.major2week = [...group.major2week, item];
          }

        return group;
      }, {
        passed: [],
        today: [],
        minor2week: [],
        major2week: [],
        invalid: [] // Nuovo gruppo per valori mancanti
      });

      setGroup(data);
    }, []);

    return (<VerticalTimeline>

      <Item
        icon={<BsCalendarX />}
        items={group?.passed}
        label={lang('Passed')}
        iconStyle={verticalItemStyles.icons.passed}
        contentArrowStyle={verticalItemStyles.contentIcon[(!!group?.passed && group?.passed.length > 0) ? 'data' : 'noData']}
        contentStyle={verticalItemStyles.content[(!!group?.passed && group?.passed.length > 0) ? 'data' : 'noData']} />

      <Item
        icon={<BsCalendarEvent />}
        items={group?.today}
        label={lang("Today")}
        iconStyle={verticalItemStyles.icons.today}
        contentArrowStyle={verticalItemStyles.contentIcon[(!!group?.today && group?.today.length > 0) ? 'data' : 'noData']}
        contentStyle={verticalItemStyles.content[(!!group?.today && group?.today.length > 0) ? 'data' : 'noData']} />

      {(group?.minor2week.length > 0) ?
        <Item
          icon={<BsCalendarWeek />}
          items={group?.minor2week}
          label={lang("< 2 Week")}
          iconStyle={verticalItemStyles.icons.minor2week}
          contentArrowStyle={verticalItemStyles.contentIcon.data}
          contentStyle={verticalItemStyles.content.data} />
        : null}

      {(group?.major2week.length > 0) ?
        <Item
          icon={<BsCalendar3 />}
          items={group?.major2week}
          label={lang("> 2 Week")}
          iconStyle={verticalItemStyles.icons.major2week}
          contentArrowStyle={verticalItemStyles.contentIcon.data}
          contentStyle={verticalItemStyles.content.data} />
        : null}
    </VerticalTimeline>)
  }

  export default Scheduling;